import { safeDate } from '../misc';

import processMinimumOrderInformation from './processMinimumOrderInformation';
import processSurcharge from './processSurcharge';
import moment from 'moment';

export default function processLocationDeliveryEstimate(
  rawDeliveryEstimate: RawLocationDeliveryEstimate,
): LocationDeliveryEstimate {
  const minimumOrderInformation = processMinimumOrderInformation(
    rawDeliveryEstimate.MinimumOrderInfo,
  );

  return {
    deliveryProvider: {
      id: rawDeliveryEstimate.DeliveryProvider as number,
      name: rawDeliveryEstimate.DeliveryProviderDescription as string,
    },
    locationId: (rawDeliveryEstimate.StoreId
      ? String(rawDeliveryEstimate.StoreId)
      : undefined) as string,
    bestDeliveryTime: safeDate(rawDeliveryEstimate.BestDeliveryTime) as string,
    surcharges: (rawDeliveryEstimate.Surcharges || []).map(processSurcharge),
    minimumOrderInformation,
    timeEstimateReturned: safeDate(moment().format()) as string,
    bestEstId: rawDeliveryEstimate.BestEstID,
  };
}
